import React from 'react';
import RestrictedAccess from '../../Owner/RestrictedAccess';

const ExperienceAccess = () => {
    return <RestrictedAccess />;
};

export default ExperienceAccess;
